module.exports = __webpack_public_path__ + "img/13.09a075cc.png";